// GitHub organization configuration
export const GITHUB_ORG = 'Ksymmetry';
